module.exports = __webpack_public_path__ + "img/223.0b10519b.png";